import {
  colorPastelBlue,
  colorPastelGreen,
  colorPastelOrange,
  colorPastelPurple,
  colorPastelRed,
  colorPastelYellow
} from "../shared/colors";
import {ChatPersonaType} from "../toktiv-common/types";
import {$KTM, KeyMetadatas} from "../shared/types";

export type AvatarConfig = {
  parts: {
    id: string,
    value: number,
  }[],
  color?: string,
  flip?: boolean,
  blobSeed?: number,
}

export type ChatPersonaAppearance = {
  color: string,
  avatarConfig?: AvatarConfig,
}

export const CHAT_PERSONA_APPEARANCE_KTM = new KeyMetadatas<ChatPersonaAppearance>([
  $KTM(ChatPersonaType.ARYA, {
    avatarConfig: {
      parts:
        [{"id": "face", "value": 0}, {"id": "nose", "value": 10}, {"id": "mouth", "value": 7}, {
          "id": "eyes",
          "value": 0
        }, {"id": "eyebrows", "value": 11}, {"id": "glasses", "value": 0}, {
          "id": "hair",
          "value": 23
        }, {"id": "accessories", "value": 0}, {"id": "details", "value": 0}, {"id": "beard", "value": 0}],
      blobSeed: 2,
    },
    color: colorPastelYellow,
  }),
  $KTM(ChatPersonaType.SOFIE, {
    avatarConfig: {
      parts: [{"id": "face", "value": 2}, {"id": "nose", "value": 3}, {"id": "mouth", "value": 11}, {
        "id": "eyes",
        "value": 0
      }, {"id": "eyebrows", "value": 0}, {"id": "glasses", "value": 1}, {
        "id": "hair",
        "value": 53
      }, {"id": "accessories", "value": 0}, {"id": "details", "value": 0}, {"id": "beard", "value": 0}],
      blobSeed: 6,
    },
    color: colorPastelBlue,
  }),
  $KTM(ChatPersonaType.TOMO, {
    avatarConfig: {
      parts: [{"id":"face","value":2},{"id":"nose","value":13},{"id":"mouth","value":1},{"id":"eyes","value":1},{"id":"eyebrows","value":14},{"id":"glasses","value":14},{"id":"hair","value":10},{"id":"accessories","value":0},{"id":"details","value":0},{"id":"beard","value":0}],
      blobSeed: 1,
    },
    color: colorPastelRed,
  }),
  $KTM(ChatPersonaType.MAYA, {
    avatarConfig: {
      parts: [{"id":"face","value":9},{"id":"nose","value":1},{"id":"mouth","value":0},{"id":"eyes","value":7},{"id":"eyebrows","value":8},{"id":"glasses","value":0},{"id":"hair","value":18},{"id":"accessories","value":0},{"id":"details","value":0},{"id":"beard","value":0}],
      blobSeed: 8,
    },
    color: colorPastelGreen,
  }),
  $KTM(ChatPersonaType.LEO, {
    avatarConfig: {
      parts: [{"id":"face","value":3},{"id":"nose","value":4},{"id":"mouth","value":12},{"id":"eyes","value":10},{"id":"eyebrows","value":7},{"id":"glasses","value":10},{"id":"hair","value":3},{"id":"accessories","value":0},{"id":"details","value":0},{"id":"beard","value":0}],
      blobSeed: 11,
    },
    color: colorPastelOrange,
  }),
  $KTM(ChatPersonaType.AVA, {
    avatarConfig: {
      parts: [{"id":"face","value":8},{"id":"nose","value":0},{"id":"mouth","value":18},{"id":"eyes","value":10},{"id":"eyebrows","value":9},{"id":"glasses","value":0},{"id":"hair","value":56},{"id":"accessories","value":0},{"id":"details","value":0},{"id":"beard","value":0}],
      blobSeed: 26,
    },
    color: colorPastelPurple,
  }),
  $KTM(ChatPersonaType.NOAH, {
    avatarConfig: {
      parts:[{"id":"face","value":2},{"id":"nose","value":1},{"id":"mouth","value":17},{"id":"eyes","value":0},{"id":"eyebrows","value":10},{"id":"glasses","value":0},{"id":"hair","value":33},{"id":"accessories","value":0},{"id":"details","value":0},{"id":"beard","value":0}],
      blobSeed: 29,
    },
    color: colorPastelYellow,
  }),
  $KTM(ChatPersonaType.FARAH, {
    avatarConfig: {
      parts: [{"id":"face","value":2},{"id":"nose","value":0},{"id":"mouth","value":6},{"id":"eyes","value":9},{"id":"eyebrows","value":11},{"id":"glasses","value":0},{"id":"hair","value":25},{"id":"accessories","value":0},{"id":"details","value":0},{"id":"beard","value":0}],
      blobSeed: 30,
    },
    color: colorPastelBlue,
  }),
  $KTM(ChatPersonaType.MATEO, {
    avatarConfig: {
      parts: [{"id":"face","value":3},{"id":"nose","value":2},{"id":"mouth","value":19},{"id":"eyes","value":4},{"id":"eyebrows","value":5},{"id":"glasses","value":13},{"id":"hair","value":31},{"id":"accessories","value":0},{"id":"details","value":0},{"id":"beard","value":0}],
      blobSeed: 35,
    },
    color: colorPastelRed,
  }),
  $KTM(ChatPersonaType.AMIT, {
    avatarConfig: {
      parts: [{"id":"face","value":14},{"id":"nose","value":1},{"id":"mouth","value":0},{"id":"eyes","value":12},{"id":"eyebrows","value":5},{"id":"glasses","value":0},{"id":"hair","value":51},{"id":"accessories","value":0},{"id":"details","value":0},{"id":"beard","value":0}],
      blobSeed: 36,
    },
    color: colorPastelGreen,
  }),
  $KTM(ChatPersonaType.PAUL, {
    avatarConfig: {
      parts: [{"id": "face", "value": 4}, {"id": "nose", "value": 5}, {"id": "mouth", "value": 14}, {
        "id": "eyes",
        "value": 10
      }, {"id": "eyebrows", "value": 13}, {"id": "glasses", "value": 3}, {
        "id": "hair",
        "value": 46
      }, {"id": "accessories", "value": 0}, {"id": "details", "value": 0}, {"id": "beard", "value": 0}],
      blobSeed: 39,
    },
    color: colorPastelOrange,
  }),
  $KTM(ChatPersonaType.MIKO, {
    avatarConfig: {
      parts: [{"id":"face","value":9},{"id":"nose","value":6},{"id":"mouth","value":2},{"id":"eyes","value":4},{"id":"eyebrows","value":2},{"id":"glasses","value":0},{"id":"hair","value":16},{"id":"accessories","value":0},{"id":"details","value":0},{"id":"beard","value":0}],
      blobSeed: 42,
    },
    color: colorPastelPurple,
  }),
]);
